import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SchoolLogo } from './UI';

const NAV_ITEMS = [
  { path: '/dashboard',    icon: '', label: 'Dashboard',   section: 'main' },
  { path: '/bookings',     icon: '', label: 'Booking LE',  section: 'main' },
  { path: '/new-booking',  icon: '', label: 'New Booking LE', section: 'main' },
  { path: '/calendar',     icon: '', label: 'Calendar',    section: 'main' },
  { path: '/approvals',    icon: '', label: 'Approvals',   section: 'management' },
  { path: '/areas',        icon: '', label: 'Event Areas', section: 'management' },
  { path: '/assets',       icon: '', label: 'Assets',      section: 'management' },
  { path: '/users',        icon: '', label: 'Users',       section: 'admin' },
  { path: '/email-config', icon: '', label: 'Email Config', section: 'admin' },
  { path: '/holidays',     icon: '', label: 'Holidays',    section: 'admin' },
  { path: '/settings',     icon: '', label: 'Settings',    section: 'admin' },
];

const MOBILE_ITEMS = [
  { path: '/dashboard',   icon: '', label: 'Home' },
  { path: '/bookings',    icon: '', label: 'Booking LE' },
  { path: '/new-booking', icon: '', label: 'New Booking LE' },
  { path: '/calendar',    icon: '', label: 'Calendar' },
  { path: '/approvals',   icon: '', label: 'Approvals' },
];

export default function Layout({ children, pendingCount = 0 }) {
  const { user, isAdmin, isManagement, isViewer, logout } = useAuth();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const initials = user?.fullName
    ? user.fullName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  // Filter nav items by role
  const visibleItems = NAV_ITEMS.filter(item => {
    if (item.section === 'admin')      return isAdmin;
    if (item.section === 'management') return isManagement;
    if (isViewer) return item.path === '/calendar';
    return true;
  });

  const grouped = ['main', 'management', 'admin'].map(sec => ({
    sec,
    items: visibleItems.filter(i => i.section === sec)
  })).filter(g => g.items.length > 0);

  const sectionLabel = { main: 'Main', management: 'Management', admin: 'Admin' };

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className="app-shell" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Topbar */}
      <header className="app-topbar" style={{
        background: 'var(--white)', borderBottom: '1.5px solid var(--border)',
        padding: '0 1.5rem', height: 62, display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 200,
        boxShadow: 'var(--shadow)'
      }}>
        <div className="app-topbar-left" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <SchoolLogo size={38} />
          <div>
            <div className="app-brand-title" style={{ fontFamily: 'var(--font-head)', fontSize: 16, fontWeight: 700, lineHeight: 1.2 }}>Elpro Schools</div>
            <div className="logo-sub" style={{ fontSize: 11, color: 'var(--text2)', fontWeight: 500 }}>Booking LE</div>
          </div>
        </div>

        <div className="app-topbar-right" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {user?.campusName && (
            <div className="campus-chip" style={{ background: 'var(--blue-light)', color: 'var(--blue-dark)', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 20 }}>
              Campus: {user.campusName}
            </div>
          )}
          {!isViewer && (
          <button className="topbar-icon-btn" onClick={() => navigate('/approvals')} style={{
            width: 36, height: 36, borderRadius: '50%', background: 'var(--bg2)', border: 'none',
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
            position: 'relative', fontSize: 16
          }}>
            N
            {pendingCount > 0 && (
              <span style={{ position: 'absolute', top: 6, right: 6, width: 8, height: 8, background: 'var(--red)', borderRadius: '50%', border: '2px solid white' }} />
            )}
          </button>
          )}
          <div style={{ position: 'relative' }}>
            <button className="topbar-avatar-btn" onClick={() => setShowUserMenu(!showUserMenu)} style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'linear-gradient(135deg,var(--blue),var(--green))',
              color: '#fff', border: 'none', fontSize: 13, fontWeight: 700, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>{initials}</button>
            {showUserMenu && (
              <div style={{
                position: 'absolute', top: 44, right: 0, background: 'white',
                border: '1.5px solid var(--border)', borderRadius: 12, padding: '8px 0',
                minWidth: 180, boxShadow: 'var(--shadow-md)', zIndex: 300
              }}>
                <div style={{ padding: '8px 16px', borderBottom: '1px solid var(--border)', marginBottom: 4 }}>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{user?.fullName}</div>
                  <div style={{ fontSize: 11, color: 'var(--text2)' }}>{user?.email}</div>
                  <div style={{ fontSize: 11, color: 'var(--blue)', fontWeight: 600, marginTop: 2 }}>{user?.roleName}</div>
                </div>
                <button onClick={() => { navigate('/profile'); setShowUserMenu(false); }} style={{ width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, fontFamily: 'var(--font-body)' }}>My Profile</button>
                <button onClick={handleLogout} style={{ width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer', fontSize: 13, color: 'var(--red)', fontFamily: 'var(--font-body)' }}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </header>

      <div style={{ display: 'flex', flex: 1 }}>
        {/* Sidebar */}
        <aside className="sidebar-desktop" style={{
          width: 230, background: 'var(--white)', borderRight: '1.5px solid var(--border)',
          padding: '1.2rem 0', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 4
        }}>
          {grouped.map(g => (
            <React.Fragment key={g.sec}>
              <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.08em', padding: '12px 1.4rem 4px', marginTop: 8 }}>
                {sectionLabel[g.sec]}
              </div>
              {g.items.map(item => {
                const active = location.pathname === item.path;
                const count  = item.path === '/approvals' ? pendingCount : 0;
                return (
                  <button key={item.path} onClick={() => navigate(item.path)} style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '10px 1.4rem', margin: '0 .6rem', borderRadius: 'var(--radius-sm)',
                    cursor: 'pointer', transition: 'all .18s', fontSize: 14, fontWeight: 600,
                    color: active ? 'var(--blue)' : 'var(--text2)',
                    background: active ? 'var(--blue-light)' : 'none', border: 'none',
                    width: 'calc(100% - 1.2rem)', textAlign: 'left', fontFamily: 'var(--font-body)'
                  }}>
                    {item.icon ? <span style={{ fontSize: 18, width: 22, textAlign: 'center' }}>{item.icon}</span> : null}
                    <span style={{ flex: 1 }}>{item.label}</span>
                    {count > 0 && (
                      <span style={{ background: 'var(--red)', color: 'white', fontSize: 10, fontWeight: 700, width: 18, height: 18, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{count}</span>
                    )}
                  </button>
                );
              })}
            </React.Fragment>
          ))}
          <div style={{ flex: 1 }} />
          <div style={{ padding: '1rem .6rem' }}>
            <button onClick={handleLogout} style={{
              width: '100%', padding: '9px 18px', background: 'var(--bg2)', color: 'var(--text1)',
              border: '1.5px solid var(--border)', borderRadius: 'var(--radius-sm)',
              cursor: 'pointer', fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-body)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6
            }}>
              Logout
            </button>
          </div>
        </aside>

        {/* Main content */}
        <main className="app-main" style={{ flex: 1, padding: '1.8rem', overflowX: 'hidden', paddingBottom: 'max(1.8rem, 88px)' }}>
          {children}
        </main>
      </div>

      {/* Mobile bottom nav */}
      <nav style={{
        display: 'none', position: 'fixed', bottom: 0, left: 0, right: 0,
        background: 'white', borderTop: '1.5px solid var(--border)', padding: '6px 0 10px',
        zIndex: 300, boxShadow: '0 -4px 16px rgba(0,0,0,.08)'
      }} className="mobile-nav-bar">
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          {MOBILE_ITEMS.filter(item => !isViewer || item.path === '/calendar').map(item => {
            const active = location.pathname === item.path;
            return (
              <button key={item.path} onClick={() => navigate(item.path)} style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                cursor: 'pointer', padding: '4px 10px', borderRadius: 'var(--radius-sm)',
                border: 'none', background: 'none', fontFamily: 'var(--font-body)'
              }}>
                {item.icon ? <span style={{ fontSize: 20 }}>{item.icon}</span> : null}
                <span style={{ fontSize: 10, fontWeight: 700, color: active ? 'var(--blue)' : 'var(--text2)' }}>{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>

      <style>{`
        @media(max-width:768px){
          .app-topbar{
            height:auto!important;
            min-height:62px!important;
            padding:8px 10px!important;
          }
          .app-topbar-left{gap:6px!important; min-width:0;}
          .app-topbar-right{gap:6px!important; min-width:0;}
          .app-brand-title{font-size:13px!important; line-height:1.1!important;}
          .campus-chip{
            max-width:120px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            padding:3px 8px!important;
            font-size:11px!important;
          }
          .topbar-icon-btn,.topbar-avatar-btn{
            width:34px!important;
            height:34px!important;
            flex-shrink:0;
          }
          .app-main{
            padding:12px!important;
            padding-bottom:max(12px, 84px)!important;
          }
          .sidebar-desktop{display:none!important}
          .mobile-nav-bar{display:block!important}
          .logo-sub{display:none}
        }
      `}</style>
    </div>
  );
}

